import { render, staticRenderFns } from "./Payment-Terms.vue?vue&type=template&id=f652e848"
import script from "./Payment-Terms.vue?vue&type=script&lang=js"
export * from "./Payment-Terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports